module.exports = __webpack_public_path__ + "img/enrique-fernandez-chacon.bebb2181.png";